module.exports = __webpack_public_path__ + "e0b7679452931903382ed0aad4bb0d11.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/mythos-2.jpg
// module id = 808
// module chunks = 0